import React from 'react';
import { Spin } from 'antd';
import './spinner.css';

export default () => <div className="overlay"><Spin tip="Loading..." size="large" /></div>



// WEBPACK FOOTER //
// ./src/components/spinner/spinner.js